import React from 'react';
import { IconProps } from '../icons/icons';

/**
 * Check circle icon SVG component
 */
export const CheckCircle: React.FC<
  IconProps & { size?: number; color?: string }
> = ({ size = 16, color = 'var(--text-primary)', ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.99992 1.33337C4.31992 1.33337 1.33325 4.32004 1.33325 8.00004C1.33325 11.68 4.31992 14.6667 7.99992 14.6667C11.6799 14.6667 14.6666 11.68 14.6666 8.00004C14.6666 4.32004 11.6799 1.33337 7.99992 1.33337ZM6.66659 11.3334L3.33325 8.00004L4.27325 7.06004L6.66659 9.44671L11.7266 4.38671L12.6666 5.33337L6.66659 11.3334Z'
      fill={color}
    />
  </svg>
);

export default CheckCircle;
